import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: ''
        };
    }

    static getDerivedStateFromError(error) {
        return { error: error };
    }

    componentDidCatch(error) {
        this.setState({ error: error });
    }

    render() {
        if (this.state.error && this.props.shouldSwallow === false) {
            return (<div className="alert alert-danger">
            {
                <span style={{fontWeight: "bold", "marginRight": "5px"}}>{this.props.errorPrefix + ":"}</span>
            }
            {
                this.state.error.message
            }
            </div>)
        } else {
            return this.props.children;
        }
    }
}

ErrorBoundary.propTypes = {
    errorPrefix: PropTypes.string,
    children: PropTypes.object.isRequired,
    shouldSwallow: PropTypes.bool.isRequired
};

export default ErrorBoundary;